/**
 * Safari-safe file download.
 *
 * Safari often blocks blob URLs with "WebKitBlobResource error 1".
 * This helper tries the standard <a download> approach first, then
 * falls back to reading the blob as a data URL on failure.
 */
export function safeSaveAs(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);

  try {
    a.click();
  } catch {
    // Blob URL blocked (Safari) — fall back to data URL
    dataUrlFallback(blob, filename);
  }

  // Clean up after a short delay to let the download start
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 100);
}

function dataUrlFallback(blob: Blob, filename: string): void {
  const reader = new FileReader();
  reader.onloadend = () => {
    const a = document.createElement('a');
    a.href = reader.result as string;
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    setTimeout(() => document.body.removeChild(a), 100);
  };
  reader.readAsDataURL(blob);
}
